module.exports = __webpack_public_path__ + "static/image20@2x-a76d760812ced8517c985ccb29066156.jpg";